<template>
  <div>
    <b-row class="mb-3">
      <b-col cols="12" md="6" lg="3">
        <h2>GBQ Management</h2>
      </b-col>
    </b-row>
    <b-tabs content-class="mt-3">
      <b-tab title="Brands Markets Configs" lazy>
        <brands-markets />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import BrandsMarkets from "./BrandsMarkets.vue";
export default {
  name: 'SmartGrabberManagement',
  components: { BrandsMarkets },
};
</script>

<style scoped></style>